import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "../../BaseUI/Modal";
import Input from "../../BaseUI/Input";
import Button from "../../BaseUI/Button";

/**
 * Shared reject modal for approval flows.
 * variant: "simple" (optional reason) | "confirm" (shows subject + textarea)
 */
const ApprovalRejectModal = ({
  isOpen,
  onClose,
  title = "Reddet",
  subjectLabel = "",
  reason = "",
  onReasonChange,
  onConfirm,
  loading = false,
  variant = "simple",
  confirmLabel = "Reddet",
  reasonLabel = "Red nedeni (isteğe bağlı)",
  reasonPlaceholder,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} width={variant === "confirm" ? "small" : "medium"}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        {variant === "confirm" && subjectLabel && (
          <p className="text-muted mb-3">
            <strong>{subjectLabel}</strong> kaydını reddetmek istediğinizden emin
            misiniz?
          </p>
        )}
        <Input
          type={variant === "confirm" ? "textarea" : undefined}
          label={variant === "confirm" ? "Red Nedeni" : reasonLabel}
          value={reason}
          onChange={onReasonChange}
          placeholder={reasonPlaceholder}
          rows={variant === "confirm" ? 3 : undefined}
        />
      </ModalBody>
      <ModalFooter>
        <Button appearance={variant === "confirm" ? "subtle" : "default"} onClick={onClose}>
          İptal
        </Button>
        <Button
          appearance={variant === "confirm" ? "danger-subtle" : "danger"}
          onClick={onConfirm}
          loading={loading}
        >
          {confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ApprovalRejectModal;
